import { createAction } from 'redux-actions';

import authClaimsRepository from '../../../auth/domain/repositories/AuthClaimsRepository';
import UserAgent from '../../../uq-ui/helpers/express-useragent';

const namespace = 'APP';

const Bowser = require("bowser");

export const showChangeBrowserModal = createAction(`${namespace}/SHOW_CHANGE_BROWSER_MODAL`);
export const hideChangeBrowserModal = createAction(`${namespace}/HIDE_CHANGE_BROWSER_MODAL`);

export function checkBrowser() {
  return (dispatch, getState) => {
    const userAgent = new UserAgent().parse(navigator.userAgent);
    const browserParser = Bowser.getParser(window.navigator.userAgent);
    const browser = browserParser.getBrowser();
    const browserName = browser.name;
    if (userAgent.isAndroid) {
      if (browserName !== 'Chrome') {
        dispatch(showChangeBrowserModal());
      } else {
        authClaimsRepository.checkHeaders()
        .then(res => {
          if (res.data.isWebview) {
            dispatch(showChangeBrowserModal());
          }
        })
        .catch(err => console.log(err));
      }
    } else if (userAgent.isiPad || userAgent.isiPod || userAgent.isiPhone) {
      if (!userAgent.browser.includes('Safari')) {
        dispatch(showChangeBrowserModal());
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/app/modules/app/store/check-browser/actions.ts